export class GlobalConstants {
  public static MENU_EXCLUDED_ROUTE = '/table/fullView/';
}
